module.exports = __webpack_public_path__ + "img/1.26d62aa3.png";